import styled from '@emotion/styled';

export const RoomField = styled.div`
	position: relative;
`;

export const RoomInput = styled.div<{ hidden: boolean }>`
	display: ${({ hidden }) => (hidden ? 'none' : 'block')};
`;
